// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mG","show":"mH","dark":"mI","top":"mJ","bottom":"mK","left":"mL","right":"mM"};